import { produce } from 'immer';
import { share } from 'shared-zustand';
import { create } from 'zustand';
import { subscribeWithSelector, persist } from '../../node_modules/zustand/esm/middleware.js';
import { shallow as shallow$1 } from '../../node_modules/zustand/esm/shallow.js';
import { useDevelopmentFlag } from './hooks/useDevelopmentFlag.js';
import { delayedTrackZustand } from '@fabric-app/compat/capabilities/openreplay';

var FeatureFlag = /* @__PURE__ */ function(FeatureFlag2) {
  FeatureFlag2["EXPERIMENTAL_ASSISTANT"] = "EXPERIMENTAL_ASSISTANT";
  FeatureFlag2["REACT_QUERY_DEVTOOLS"] = "REACT_QUERY_DEVTOOLS";
  FeatureFlag2["UPLOAD_DEVTOOLS"] = "UPLOAD_DEVTOOLS";
  FeatureFlag2["IN_APP_RATING_RESETABLE"] = "IN_APP_RATING_RESETABLE";
  FeatureFlag2["SMART_COLLECTIONS_PRECISION"] = "SMART_COLLECTIONS_PRECISION";
  FeatureFlag2["NOTEPAD_NEW_UPDATE_SERVICE"] = "NOTEPAD_NEW_UPDATE_SERVICE";
  FeatureFlag2["NEW_SEARCH_ITEM_VIEW"] = "NEW_SEARCH_ITEM_VIEW";
  FeatureFlag2["PROSEMIRROR_DEV_TOOLS"] = "PROSEMIRROR_DEV_TOOLS";
  FeatureFlag2["SEARCH_PARAM_CUSTOMIZATION"] = "SEARCH_PARAM_CUSTOMIZATION";
  FeatureFlag2["ALLOW_REPEATING_ASSISTANT_DIFFS"] = "ALLOW_REPEATING_ASSISTANT_DIFFS";
  return FeatureFlag2;
}({});
const initialFlags = {
  ["EXPERIMENTAL_ASSISTANT"]: false,
  ["REACT_QUERY_DEVTOOLS"]: false,
  ["UPLOAD_DEVTOOLS"]: false,
  ["IN_APP_RATING_RESETABLE"]: false,
  ["SMART_COLLECTIONS_PRECISION"]: false,
  ["NOTEPAD_NEW_UPDATE_SERVICE"]: false,
  ["NEW_SEARCH_ITEM_VIEW"]: false,
  ["PROSEMIRROR_DEV_TOOLS"]: false,
  ["SEARCH_PARAM_CUSTOMIZATION"]: false,
  ["ALLOW_REPEATING_ASSISTANT_DIFFS"]: false
};
const useFeatureFlagsStore = create()(delayedTrackZustand(subscribeWithSelector(persist((set, get) => ({
  flags: initialFlags,
  setFlag: (flag, value) => set(produce(get(), (draft) => {
    draft.flags[flag] = value;
  })),
  toggleFlag: (flag) => set(produce(get(), (draft) => {
    draft.flags[flag] = !draft.flags[flag];
  }))
}), {
  name: "feature-flags",
  version: 1.1,
  migrate: (persistedState) => {
    const state = persistedState;
    const flags = Object.values(FeatureFlag);
    const newState = {
      ...state,
      flags: Object.fromEntries(flags.map((flag) => [
        flag,
        state.flags[flag] ?? initialFlags[flag]
      ]))
    };
    return newState;
  }
}))));
if ("BroadcastChannel" in globalThis) {
  share("flags", useFeatureFlagsStore);
}
const useIsFeatureFlagEnabled = (flag) => {
  const accessToDevelopmentFlags = useDevelopmentFlag();
  const flagEnabled = useFeatureFlagsStore((state) => flag && state.flags[flag] === true, shallow$1);
  return flagEnabled && accessToDevelopmentFlags;
};
const useFeatureFlags = () => {
  const accessToDevelopmentFlags = useDevelopmentFlag();
  const flags = useFeatureFlagsStore((state) => Object.values(FeatureFlag).map((flag) => ({
    flag,
    value: state.flags[flag]
  })));
  const setFlag = useFeatureFlagsStore((state) => state.setFlag);
  const toggleFlag = useFeatureFlagsStore((state) => state.toggleFlag);
  if (!accessToDevelopmentFlags) {
    return {
      flags: [],
      setFlag: () => {
      },
      toggleFlag: () => {
      }
    };
  }
  return {
    flags,
    setFlag,
    toggleFlag
  };
};

export { FeatureFlag, useFeatureFlags, useIsFeatureFlagEnabled };
//# sourceMappingURL=feature-flags.store.js.map
